import {Injectable, signal} from '@angular/core';
import {ActivatedRoute, ActivationEnd, NavigationEnd, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';

export interface LayoutData {
  hideAll?: boolean;
  narrowMainContainer?: boolean;
  greyBackground?: boolean;
  hideWidget?: boolean;
}

@Injectable()
export class LayoutService {
  public areLayoutElementsHidden = signal<boolean>(null);
  public shouldUseNarrowMainContainer = signal<boolean>(null);
  public shouldUseGreyBackground = signal<boolean>(null);
  public isTopSearchWidgetHidden = signal<boolean>(null);
  private currentRouteData: Observable<LayoutData>;

  constructor(
    private route: ActivatedRoute,
    router: Router,
  ) {
    this.currentRouteData = router.events.pipe(
      filter((event) => event instanceof NavigationEnd || event instanceof ActivationEnd),
      map(() => this.route.snapshot),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route.data.layout;
      }),
    );

    this.currentRouteData.pipe(map((layoutData: LayoutData) => !!layoutData?.hideAll)).subscribe((hideAll) => {
      this.areLayoutElementsHidden.set(hideAll);
    });

    this.currentRouteData.pipe(map((layoutData: LayoutData) => !!layoutData?.hideWidget)).subscribe((hideWidget) => {
      this.isTopSearchWidgetHidden.set(hideWidget);
    });

    this.currentRouteData
      .pipe(map((layoutData: LayoutData) => !!layoutData?.narrowMainContainer))
      .subscribe((narrowMainContainer) => {
        this.shouldUseNarrowMainContainer.set(narrowMainContainer);
      });

    this.currentRouteData
      .pipe(map((layoutData: LayoutData) => !!layoutData?.greyBackground))
      .subscribe((greyBackground) => {
        this.shouldUseGreyBackground.set(greyBackground);
      });
  }

  public setShouldUseGreyBackground(state: boolean): void {
    this.shouldUseGreyBackground.set(state);
  }

  public setShouldHideTopSearchWidget(state: boolean): void {
    this.isTopSearchWidgetHidden.set(state);
  }
}
